import { useState } from "react";
import PurchaseOrderForm from "./PurchaseOrderForm";
import PurchaseOrderListview from "./PurchaseOrderListview";

const PurchaseOrder = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
        <PurchaseOrderForm
          addForm={setFromIsShown}
          update={upData}
          sId={serviceId}
        />
      ) : (
        <PurchaseOrderListview
          addForm={setFromIsShown}
          update={setUpData}
          sId={setServiceId}
        />
      )}
    </>
  );
};

export default PurchaseOrder;
